// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"story-card-m__wrapper__1X7yE"};